var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:_vm.theme.stylesheet},[_c('ModalService'),_c('ToastService'),_c('OverlayService'),(_vm.widget)?_c('ThemeWidget'):_vm._e(),_c('GlobalNav',[_c('router-view')],1),_c('CartStack')],1)}
var staticRenderFns = []

export { render, staticRenderFns }